import { useState, useEffect } from "react";
import FormLayout from "src/layouts/FormLayout";
import { Row, Col } from "src/components/layout";
import { Input } from "@porchpass/ui";

export default () => {
  const [signingUrl, setSigningUrl] = useState("");
  const [clientId, setClientId] = useState("");

  useEffect(() => {
    if (clientId.length > 0 && signingUrl.length > 0) {
      const docusignInit = async () => {
        const docusign = await window.DocuSign.loadDocuSign(clientId);
        const signing = docusign.signing({
          url: signingUrl,
          displayFormat: "focused",
        });

        signing.on("sessionEnd", (evt) =>
          console.log("DOCUSIGN SESSION END:: ", evt),
        );
        signing.on("ready", (evt) => console.log("DOCUSIGN READY", evt));
        signing.mount("#docusign");
      };

      void docusignInit();
    }
  }, [clientId, signingUrl]);

  return (
    <FormLayout
      title="Docusign Embed Test"
      subtitle="Just a test, if this was an actual emergency..."
      headerTitle="Docusign Signature Testing"
    >
      <Row>
        <Col>
          Signing URL
          <Input
            label="signing-url"
            name="signing-url"
            value={signingUrl}
            onChange={(event) => setSigningUrl(event.target.value)}
          />
          Client ID
          <Input
            label="clientId"
            name="clientId"
            value={clientId}
            onChange={(event) => setClientId(event.target.value)}
          />
        </Col>
      </Row>
    </FormLayout>
  );
};
